import * as React from 'react';
export const GRSvg = React.forwardRef(function GRSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#43458B',
      d: 'M14 14H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#fff',
      d: 'M6.66 3.333H16v1.333H6.66zM6.66 6H16v1.333H6.66zM0 8.667h16V10H0zm0 2.666h16v1.333H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#fff',
      fillRule: 'evenodd',
      d: 'M2.668 4.668V2h1.334v2.668H6.67v1.334H4.002V8.67H2.668V6.002H0V4.668h2.668Z',
      clipRule: 'evenodd',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#43458B',
      fillOpacity: 0.1,
      fillRule: 'evenodd',
      d: 'M2 14h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2ZM14 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12Z',
      clipRule: 'evenodd',
    }),
  );
});
GRSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var GR = {
  category: 'flag',
  colorable: false,
  name: 'GR',
  svg: GRSvg,
};
